import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { reducers } from './store';
import { reducer as oidcReducer } from 'redux-oidc';

export default (history) => combineReducers(Object.assign({}, reducers, {
    router : connectRouter(history),
    oidc: oidcReducer
}));